
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { FactoryService } from '@services/common/factory.service';
import { ComRouteService } from '@services/common/com-route.service';

@Injectable({
    providedIn: 'root'
  })
export class PincodeGuard{

  constructor(
    private factorySer: FactoryService,
    private comRoute: ComRouteService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (/(learn-more)/.test(state?.url)) {
      return true;
    } else { 
      const pinType = this.factorySer.getPinType();
      const logined = this.factorySer.getLoginStatus();
      // if phonepin flow with login statu, then can't enter pincode page again and should go to routing logic
      if (logined && pinType === 'phonePin') {
        this.factorySer.setSinglePop();
        return true;
      } else { 
        const logInfo = this.factorySer.getSessionInfo('logInfo', true);
        const passInfo = this.factorySer.getSessionInfo('passInfo', true);
        //enter pincode page should with logInfo or passInfo(captcha pass), otherwise should go to do login
        if (logInfo || passInfo) {
          return true;
        } else { 
          console.log('enter pin-code no logInfo..');
          //there is no login statu, so go to login page
          this.comRoute.route('login', false, { replaceUrl: true });
          return false;
        }
      }
    }
  }
}